import React, { FC } from 'react';
import { MixpanelEvents } from 'integrations/mixpanel/Events/MixpanelEvents';
import { useMixpanel } from 'integrations/mixpanel/useMixpanel';
import { ExportEventDetails } from 'integrations/mixpanel/Events/general';
import { DataTablePluginExporter } from '@utmost.co/utmost-design-system';
import { useExportsTo } from 'src/utils/hooks/data/exports/useExportsTo';
import { ExportSource } from 'src/utils/hooks/data/exports/utils/Exports.types';
import { JobProfileQueryModelInput, OcCsvExportQueryModelInput } from 'src/graphql/types';
import { useJobCataloguesIntl } from '@oc/pages/settings/Engagements/JobCatalogues/translations/useJobCataloguesIntl';

type JobProfileFilterModel = Omit<Partial<JobProfileQueryModelInput>, 'search'> & { search?: string };

export const JobProfileExporter: FC = () => {
  const { track } = useMixpanel();
  const intl = useJobCataloguesIntl();
  const exportJobProfile = useExportsTo();

  return (
    <DataTablePluginExporter<JobProfileFilterModel>
      exportFileFormats={['CSV', 'XLSX']}
      onExport={(quickReport, fileFormat, source, quickReportName) => {
        const mode = fileFormat === 'CSV' ? 'batch-csv' : 'batch-excel';
        track<ExportEventDetails>(MixpanelEvents.general.EXPORT, {
          exportType: mode,
          exportEntity: 'job_profile',
          origin: source ?? 'unknown'
        });
        exportJobProfile({
          query: { jobProfiles: {} as OcCsvExportQueryModelInput['jobProfiles'] },
          mode,
          reportName: intl.jobProfiles,
          source: ExportSource.JobProfiles
        });
      }}
      onOpen={() => {
        track(MixpanelEvents.quickReport.CHIP_OPEN_EXPORT_MENU_CLICK, { view: 'Job Profiles' });
      }}
    />
  );
};
